import axios from "axios";
import DOMPurify from "dompurify";

export const sendOtp = async (user) => {
    try {
        const url = `${process.env.REACT_APP_API}/sms/so`;
        const data = {
            email: DOMPurify.sanitize(user.email, {
                ALLOWED_ATTR: [],
                ALLOWED_TAGS: [],
            }),
        };
        const res = await axios.post(url, data);
        console.log(res.data)
    } catch (error) {
        console.error(error);
    }
}